import { useState, useEffect } from "react";
import { InfoBox } from "../components/form/InfoBox";
import styles from "./CaseStudy.module.less";
import CaseStudies from "./components/CaseStudies";
import { Hero, HeroCol, HeroTitle, HeroSubtitle } from "../../components/Hero";
import { Section, SectionCol } from "../../components/Section";
import { CtaLinkButton } from "../../components/Button";
import { Customers } from "../../components/subcomponents/Customers";
import { BottomCta } from "../../components/subcomponents/BottomCta";
import { SecurityBadges } from "../../components/subcomponents/SecurityBadges";

export const CaseStudy = () => {
  const [attentionBox, setAttentionBox] = useState(false);

  useEffect(() => {
    if (window.location.state) {
      const isInfoboxPresent = window.location.state.infobox;
      if (isInfoboxPresent) setAttentionBox(true);
    }
  }, []);

  return (
    <>
      {attentionBox && <InfoBox closeModal={() => setAttentionBox(false)} type="Attention" />}
      <Hero background="violet-900" className={styles.Hero} withStarsAnimation>
        <HeroCol>
          <HeroTitle multiLine>Resource Library</HeroTitle>
          <HeroSubtitle>
            Industry leading content, helping you to unlock the power of external data and level up
            your organization
          </HeroSubtitle>
          <CtaLinkButton data-test-id="home-hero-button" />
          <Customers withMargin />
        </HeroCol>
      </Hero>
      <div className={styles.case_study}>
        <CaseStudies className={styles.overlap} />
      </div>
      <Section background="blue-800" type="one-col">
        <SectionCol>
          <BottomCta />
        </SectionCol>
      </Section>
      <Section background="blue-1000" removeBottomPadding removeTopPadding>
        <SectionCol>
          <SecurityBadges />
        </SectionCol>
      </Section>
    </>
  );
};
